<template>
    <div class="context"
         v-loading="show_view_loading"
         :element-loading-text="loading_text"
         element-loading-spinner="el-icon-warning"
         element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="header">
            <div class="search">
                <el-page-header @back="back" :content="viewTitle">
                </el-page-header>
            </div>
        </div>
        <div class="main_box">
            <div class="form">
                <div class="img_box">
                    <img-view :imgUrl="auditForm.invoice_file_url"></img-view>
                </div>
                <el-form :model="auditForm"
                         ref="bill_form"
                         size="small"
                         label-width="120px"
                         :disabled="disabled"
                         :rules="rules">
                    <el-form-item label="购买人" prop="buyer">
                        <div class="compare_box">
                            <el-input v-model="auditForm.buyer"
                                      class="width_220"></el-input>
                            <span class="right_text">{{billForm.buyer}}</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="发票代码" prop="invoice_code">
                        <div class="compare_box">
                            <el-input v-model="auditForm.invoice_code"
                                      class="width_220"></el-input>
                            <span class="right_text">{{billForm.invoice_code}}</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="发票号码" prop="invoice_no">
                        <div class="compare_box">
                            <el-input v-model="auditForm.invoice_no"
                                      class="width_220"></el-input>
                            <span class="right_text">{{billForm.invoice_no}}</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="药品名称" prop="drug_code">
                        <div class="compare_box">
                            <el-select class="width_220"
                                        @change="drugChange"
                                       v-model="auditForm.drug_code">
                                <el-option v-for="(item ,index) in drug_code_list"
                                           :label="item.product_name"
                                           :value="item.drug_code"
                                           :key="index"
                                ></el-option>
                            </el-select>
                            <span class="right_text">{{billForm.medication_name}}</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="瘤种" v-if="patient_data.tumour">
                        <div>{{patient_data.tumour}}</div>
                    </el-form-item>

                    <el-form-item
                            v-if="getUniteDrug_product_type(auditForm.drug_code)&&
                        has_count(auditForm.drug_code)"
                            label="支数"
                            prop="medication_count">
                        <div class="compare_box">
                            <el-input-number v-model="auditForm.medication_count"
                                             controls-position="right"
                                             @change="get_next_time"
                                             :min="0"></el-input-number>
                            <span class="right_text">{{billForm.medication_count}}</span>
                        </div>
                    </el-form-item>
                    <div v-else-if="has_count(auditForm.drug_code)">
                        <el-form-item label="支数(9mg)" prop="medication_count">
                            <div class="compare_box">
                                <el-input-number v-model="auditForm.sub_count1"
                                                 controls-position="right"
                                                 @change="changeNumber"
                                                 :min="0"></el-input-number>
                                <span class="right_text">{{billForm.sub_count1}}</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="支数(4.5mg)" prop="medication_count">
                            <div class="compare_box">
                                <el-input-number v-model="auditForm.sub_count2"
                                                 controls-position="right"
                                                 @change="changeNumber"
                                                 :min="0"></el-input-number>
                                <span class="right_text">{{billForm.sub_count2}}</span>
                            </div>
                        </el-form-item>
                    </div>


                    <el-form-item v-if="has_count(auditForm.drug_code)"
                                  label="类别"
                                  prop="medication_type">
                        <el-select v-model="auditForm.medication_type" class="width_220">
                            <el-option v-for="(item, index) in drug_type_list"
                                       :label="item"
                                       :value="item"
                                       :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label="发票日期" prop="invoice_date">
                        <div class="compare_box">
                            <el-date-picker
                                    v-model="auditForm.invoice_date"
                                    @change="get_next_time"
                                    type="date"
                                    class="width_220"
                                    value-format="yyyy-MM-dd"
                                    :picker-options="picker_option"
                                    placeholder="选择日期">
                            </el-date-picker>
                            <span class="right_text">{{billForm.invoice_date}}</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="默认周期天数" prop="">
                        <el-input-number v-model="patient_data.medication_cycle_days"
                                         controls-position="right"
                                         @change="get_next_time"
                                         :min="0"></el-input-number>
                    </el-form-item>
                    <el-form-item label="当前用药周期" prop="">
                        <span style="margin-right: 5px">Cycle</span>
                        <span>
                            <el-input-number v-model="patient_data.medication_cycle"
                                             controls-position="right"
                                             :min="1"></el-input-number>
                        </span>
                    </el-form-item>
                    <el-form-item v-if="!disabled" label="下次购药日期" prop="">
                        <el-date-picker
                                v-model="patient_data.next_medication_date"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item v-if="disabled" label="状态">
                        <div>
                            {{auditForm.status | showStatus}}
                        </div>
                    </el-form-item>
                </el-form>
                <div class="btn_box">
                    <el-button @click="submit_audit"
                               v-if="!disabled && powerAudit"
                               size="small"
                               type="primary">通过</el-button>
                    <el-button @click="dialogTableVisible = true"
                               v-if="!disabled && powerRefuse"
                               size="small"
                               type="danger">拒绝</el-button>
                    <el-button @click="submit_delete"
                               size="small"
                               v-if="powerDel"
                               type="danger">删除</el-button>
                    <el-button @click="nextRow" size="small">下一个</el-button>
                </div>
            </div>
            <!--<div class="line"></div>-->
            <div class="image_form" id="image_form">
                <el-carousel v-if="swiperList && swiperList.length > 0"
                             trigger="click"
                             :autoplay="false"
                             width="100%"
                             :height="carousel_height + 'px'">
                    <el-carousel-item v-for="item in swiperList" :key="item">
                        <img-view :imgUrl="item"></img-view>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>

        <el-dialog
                title="拒绝理由"
                :visible.sync="dialogTableVisible"
                :modal-append-to-body="false"
        >
            <el-table :data="tableData" @current-change="handleCurrentChange">
                <el-table-column width="50">
                    <input type="checkbox" name="" id="" slot-scope="scope" v-model="scope.row.checked">
                </el-table-column>
                <el-table-column prop="reason" label="拒绝理由">
                    <template slot-scope="scope">
                        <div style="display: flex;align-items: center;">
                            <template v-if="scope.row.id == 8">
                                {{scope.row.reason}}
                                <el-input v-model="scope.row.value" :disabled="!scope.row.checked" placeholder="请输入拒绝理由"
                                          style="width: 80%;"></el-input>
                            </template>
                            <template v-else>{{scope.row.reason}}</template>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogTableVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit_refuse">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState} from "vuex"
    import {clone} from "@/global/utils";
    import imgView from "../common/imgView"

    import {calc_times, calc_times_2 } from "../../global/calc_drug"

    export default {
        name: "auditView",
        components: {
            imgView
        },
        data() {
            const code_check = (rule, value, callback) => {
                if(!value || value == 0) {
                    callback(new Error('请输入支数'))
                }
                callback()
            };
            return {
                auditForm: {},
                billForm: {},
                patient_data: {},
                patient_data_old: {},
                swiperList: [],
                rules: {
                    buyer: [{required: true, message: '请输入购买人', trigger: 'blur'}],
                    invoice_code: [{required: true, message: '请输入发票代码', trigger: 'blur'}],
                    invoice_no: [{required: true, message: '请输入发票号码', trigger: 'blur'}],
                    drug_code: [{required: true, message: '请选择药品名称', trigger: 'blur', type: 'number'}],
                    medication_count: [{required: true,
                        validator: code_check, trigger: 'blur'}],
                    medication_type: [{required: true, message: '请选择类别', trigger: 'blur'}],
                    invoice_date: [{required: true,
                        message: '请发票日期', trigger: 'blur'}],
                },
                viewTitle: '审核',
                disabled: false,

                carousel_height: 400,

                dialogTableVisible: false,
                currentRow: null,
                tableData: [
                    {
                        id: 1,
                        checked: false,
                        reason: "发票图片无法识别，请重新拍照上传",
                    },
                    {
                        id: 2,
                        checked: false,
                        reason: "发票号码查验有误，请提供正确的发票",
                    },
                    {
                        id: 3,
                        checked: false,
                        reason: "发票日期不符合标准，请提供日期为2022年1月1日以后的发票",
                    },
                    {
                        id: 4,
                        checked: false,
                        reason:
                            "发票名称与注册用户姓名不一致，请提供与注册用户姓名一致的发票",
                    },
                    {
                        id: 5,
                        checked: false,
                        // reason: "发票内容未含达伯舒（信迪利单抗注射液），请提供正确的发票",
                        reason: "发票内容未含药品信息，请提供正确的发票",
                    },
                    {
                        id: 6,
                        checked: false,
                        reason: "此发票重复提交，请更换发票",
                    },
                    {
                        id: 7,
                        checked: false,
                        reason: "该用户和手机号已被注册，不能重复注册",
                    },
                    {
                        id: 8,
                        checked: false,
                        value: '',
                        reason: "其他（请备注）",
                    },
                ],
                picker_option: {
                    disabledDate: function (time) {
                        return time.getTime() > new Date().getTime()
                    }
                },

                // 锁定参数
                lock_time: 200,
                time_inter: null,
                show_view_loading: false,
                is_lock: false,
                is_requesting: false,

                // 配置项
                drug_type_list: [],
                cycle_days: 21,
                cycle_medication_count: 2,
                cycle_type: 'count',
                // medication_cycle_days_conf: {},

                drug_code_list: [],
            }
        },
        computed: {
            ...mapState('illuserData', {
                audit_img_id: 'audit_img_id',
                audit_img_ids: 'audit_img_ids'
            }),
            ...mapState('comInformationData', {
                authority: 'authority',
                allIllData: 'allIllData',
                // drug_code_list: 'drug_code_list',
                // medication_fields_conf: 'medication_fields_conf'
            }),
            powerAudit() {
                return this.authority.indexOf('bill-audit-pass') > -1
            },
            powerRefuse() {
                return this.authority.indexOf('bill-audit-refuse') > -1
            },
            powerDel() {
                return this.authority.indexOf('bill-audit-del') > -1
            },

            userInfo() {
                return JSON.parse(lcGet('user'))
            },
            loading_text() {
                return `还有${this.lock_time}秒将自动解锁！`
            }
        },
        filters: {
            showStatus(val) {
                return val == '1'?'待审核':
                    val == '2'?'已审核':
                        val == '3'?'已拒绝':
                                ''
            }
        },
        mounted() {
            this.getDrugList();

        },
        beforeDestroy() {
            window.removeEventListener('mousemove', this.lockNow);
            if (this.time_inter) {
                clearInterval(this.time_inter);
            }

            if(this.is_lock) {
                this.unlockNow()
            }
        },
        methods: {
            getUniteDrug_product_type(code) {
                let product_type = 1; // 1单规格  2多规格
                if(code) {
                    let conf = this.drug_code_list.filter(res => res.drug_code == code)[0];
                    product_type = conf ? conf.product_type : 1
                }
                return product_type == 1
            },
            has_count(code) {
                return !(code == 3 || code == 0)
            },

            getDrugList() {
                this.httpGet('/product/list').then(res => {
                    this.drug_code_list = res.data.data_list;

                    this.getImgForm(this.audit_img_id)
                });
            },

            back() {
                this.$emit('changeTopTab', 'tableView')
            },

            drugChange() {
                this.auditForm.medication_count = 0;
                this.auditForm.sub_count1 = 0;
                this.auditForm.sub_count2 = 0;
                this.auditForm.medication_type = '';

                this.patient_data.next_medication_date = clone(this.patient_data_old.next_medication_date);
                this.patient_data.medication_cycle = clone(this.patient_data_old.medication_cycle);
                this.get_drug_conf()
            },
            changeNumber() {
                this.auditForm.medication_count = Number(this.auditForm.sub_count1) + Number(this.auditForm.sub_count2)
                this.get_next_time()
            },

            get_drug_conf(type = '') {
                let drug_code = this.auditForm.drug_code;
                let conf = this.drug_code_list.filter(res => res.drug_code === drug_code)[0];
                let names = ['drug_type_list', 'cycle_days', 'cycle_medication_count', 'cycle_type'];
                for (let i = 0; i < names.length; i++) {
                    if (conf[names[i]]) {
                        this[names[i]] = conf[names[i]]
                    }
                }
                this.get_days(type);
            },
            get_days(type) {
                let days = this.cycle_days;
                if(type === 'first' && this.patient_data.medication_cycle_days) {
                } else {
                    this.patient_data.medication_cycle_days = Number(clone(days));
                }
                // console.log(type, days,this.patient_data, '412');
                this.get_next_time()
            },
            get_next_time() {
                let days = this.patient_data.medication_cycle_days;
                let default_count = this.cycle_medication_count;
                let cycle_type = this.cycle_type;
                let count = this.auditForm.medication_count;
                let first_time = this.auditForm.first_drug_date;
                let first_drug_date2 = this.auditForm.invoice_date;
                let cycle = this.patient_data_old.medication_cycle;
                let data = calc_times_2(
                    cycle_type,
                    default_count,
                    count,
                    first_time,
                    days,
                    first_drug_date2,
                    cycle);
                if (!data) return;
                console.log(data, '489');
                this.patient_data.next_medication_date = data.next_medication_date;
                this.patient_data.medication_cycle = data.medication_cycle;
            },
            /**
             * get_drug_conf() {
                let drug_code = this.auditForm.drug_code;
                let conf = this.medication_fields_conf;
                let names = ['drug_type_list', 'medication_cycle_days_conf'];
                for (let i = 0; i < names.length; i++) {
                    if (conf[drug_code] && conf[drug_code][names[i]]) {
                        this[names[i]] = conf[drug_code][names[i]]
                    } else {
                        this[names[i]] = conf.default_options[names[i]]
                    }
                }
                this.get_days();
            },
             get_days() {
                let conf = this.medication_cycle_days_conf;
                let days = conf.default_days;
                if (conf.time_days_base === 'tumour') {
                    if (this.patient_data && this.patient_data.tumour) {
                        let time_days = conf.time_days;
                        let tumour = this.patient_data.tumour;
                        let days_t = time_days[tumour] && time_days[tumour][0] ? time_days[tumour][0] :
                            time_days[tumour] && time_days[tumour][1] ? time_days[tumour][1] :
                                null;
                        if (days_t) {
                            days = days_t;
                        }
                    }
                }
                // console.log(days, '376');
                this.patient_data.medication_cycle_days = days;

                this.get_next_time()
            },
             get_next_time() {
                let days = this.patient_data.medication_cycle_days;
                let conf = this.medication_cycle_days_conf;
                let count = this.auditForm.medication_count;
                let first_time = this.auditForm.invoice_date;
                let data = calc_times(conf, count, first_time, days);
                if (!data) return;
                console.log(data, '489');
                this.patient_data.next_medication_date = data.next_medication_date;
            },

             * */

            getImgForm(id) {
                this.httpGet(`/invoice/submit/${id}`).then(res => {
                    this.auditForm = res.data;
                    this.billForm = clone(this.auditForm.invoice_ocr_data);
                    this.patient_data = res.data.patient_data || {};
                    this.patient_data_old = clone(this.patient_data);
                    this.swiperList = this.auditForm.fees_file_urls;
                    // 根据患者状态判断是审核还是查看
                    if (this.auditForm.status == 1) {
                        this.viewTitle = '审核';
                        this.disabled = false;

                        //    待审核的进入锁定状态
                        this.lockNow('first');
                    } else {
                        this.viewTitle = '查看';
                        this.disabled = true
                    }
                    if (res.data.drug_code && res.data.drug_code != 0) {
                        this.get_drug_conf('first')
                    }
                })
            },
            handleCurrentChange(val) {
                console.log(val);
                this.currentRow = val;
                this.tableData.forEach((data, index) => {
                    if (data.id !== val.id) {
                        data.checked = false;
                    } else {
                        data.checked = true;
                    }
                    this.$set(this.tableData, index, data)
                });
                this.$forceUpdate()
            },

            submit_audit() {
                this.$refs.bill_form.validate((valid) => {
                    if(valid) {
                        let params = {
                            ...this.auditForm,
                        };
                        params.patient_data = this.patient_data;
                        console.log(params, 'audit------');
                        this.httpPost('/invoice/submit/audit/success', params).then(res => {
                            this.$message.success('审核成功');
                            setTimeout(() => {this.nextRow()}, 1000)
                        })
                    }
                })
            },
            submit_refuse() {
                let list = this.tableData.find(l => l.checked);
                if (!list) {
                    this.$message('请选择拒绝理由');
                    return;
                }
                if (list.id == 8) {
                    if (!list.value) {
                        this.$message({
                            message: '请备注其他理由',
                            type: 'warning'
                        });
                        return
                    }
                }
                let params = {
                    submit_id: this.auditForm.submit_id,
                    reason: list.id == 8 ? list.value : list.reason
                };
                this.httpPost('/invoice/submit/audit/fail', params).then(res => {
                    this.dialogTableVisible = false;
                    this.$message.success('拒绝成功');
                    setTimeout(() => {this.nextRow()}, 1000)
                })
            },
            submit_delete() {
                this.$message.warning('该功能正在开发中...');
                return
                this.$confirm('确定删除该发票么？').then(res => {
                    this.httpDel(`/user/patient/${this.auditForm.submit_id}`).then(res => {
                        this.$message.success('删除成功！');
                        setTimeout(() => {
                            this.nextRow('del')
                        }, 1000)
                    })
                })
            },
            nextRow(type) {
                let index_ = -1;
                this.audit_img_ids.forEach((v, i) => {
                    if (v == this.auditForm.submit_id) {
                        index_ = i
                    }
                });
                if(index_ === this.audit_img_ids.length - 1) {
                    this.$message.warning('已经是最后一条了');
                    if (type && type === 'del') {
                        this.goBack()
                    } else {
                        this.getImgForm(this.auditForm.submit_id)
                    }
                } else {
                    let id = this.audit_img_ids[index_ + 1];
                    this.getImgForm(id);
                    this.$message.success('已进入下一条');
                }

            },

            /**
             * 锁定
             * */
            setKeyUp() {
                // 监听操作
                window.addEventListener('mousemove', this.lockNow);
            },
            setLockInter() {
                this.time_inter = setInterval(() => {
                    this.lock_time --;
                    this.show_view_loading = this.lock_time <= 60 && this.lock_time > 0;
                    if (this.lock_time <= 0) {
                        clearInterval(this.time_inter);
                        this.unlockNow();
                        this.$msgbox({
                            title: '警告',
                            message: '该数据已自动解锁，如需锁定请点击锁定！',
                            showCancelButton: true,
                            confirmButtonText: '锁定',
                            cancelButtonText: '下一个',
                        }).then(() => {
                            this.lockNow()
                        }).catch(() => {
                            this.nextRow('del')
                        })
                    }
                }, 1000)
            },
            changeLockTime() {
                /**
                 * 待审核锁定，10分钟后自动解锁
                 * 操作的情况下5分钟重新锁定，重新计算时间
                 * 不操作，9分钟的时候进行提示，还不操作即锁定
                 */
                this.show_view_loading = false;
                this.lock_time = 590;
            },
            lockNow(type) {
                if (this.lock_time > 300) return; // 自动锁定时间不到一半的时候再通过
                if(this.is_requesting) return;
                this.is_requesting = true;
                let params = {
                    submit_id: this.auditForm.submit_id
                };
                this.httpGet('/invoice/submit/lock', params).then(res => {
                    this.is_requesting = false;
                    if (res.data.success) {
                        this.is_lock = true;
                        this.changeLockTime();
                        if (this.time_inter) {
                            clearInterval(this.time_inter);
                        }
                        this.setLockInter();
                        console.log('锁定成功');
                        if(type === 'first') {
                            this.setKeyUp()
                        }
                    } else {
                        this.$message.warning('该条数据已被其他人锁定！');
                        setTimeout(() => {
                            this.nextRow('del')
                        }, 10)
                    }
                })
            },
            unlockNow() {
                let params = {
                    submit_id: this.auditForm.submit_id
                };
                this.httpGet('/invoice/submit/unlock', params).then(res => {
                    this.is_lock = false;
                    this.lock_time = 200;
                    if (this.time_inter) {
                        clearInterval(this.time_inter);
                    }
                    console.log('解锁成功');
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        background: #fff;
        .header {
            height: 45px;
            line-height: 45px;

            display: flex;
            justify-content: space-between;
            padding: 0 20px;
            .search {
                padding-top: 15px;
            }
        }
        .main_box {
            display: flex;
            height: calc(100% - 50px);
            overflow: hidden;
            .form {
                flex: 1;
                height: 100%;
                overflow: hidden;
                overflow-y: auto;
                padding: 0 5px;
                box-sizing: border-box;
                .img_box {
                    width: 100%;
                    height: 400px;
                    text-align: center;
                    margin-bottom: 10px;
                    border-bottom: 1px solid #ccc;
                }
                .compare_box {
                    .right_text {
                        padding-left: 20px;
                    }
                }

                .btn_box {
                    padding-left: 120px;
                    display: flex;
                    flex-wrap: wrap;
                    .el-button {
                        margin-bottom: 5px;
                    }
                }
            }
            .line {
                width: 1px;
                height: 100%;
                background: #ccc;
            }
            .image_form {
                flex: 1;
                height: 100%;
                padding: 0 5px;
                box-sizing: border-box;
            }
        }

    }
</style>